import { z } from 'zod';

export const consumerSearchRequestSchema = z.object({
  uniqueId: z.string().optional(),
  name: z.string().optional(),
  surname: z.string().optional(),
  email: z.string().optional(),
  phoneNumber: z.string().optional(),
  pageNumber: z.number().optional(),
  pageSize: z.number().optional(),
});

export const consumerDetailResponseSchema = z.object({
  id: z.string().nullable(),
  name: z.string().nullable(),
  surname: z.string().nullable(),
  email: z.string().nullable(),
  phoneNumber: z.string().nullable(),
  birthDate: z.string().nullable(),
  channel: z.string().nullable(),
  consents: z.array(z.object({ type: z.string(), value: z.boolean() })).nullable(),
  createdDate: z.string().nullable(),
});

export type ConsumerDetailResponse = z.infer<typeof consumerDetailResponseSchema>;

export const deleteConsumerResponseSchema = z.any();

export type DeleteConsumerResponse = z.infer<typeof deleteConsumerResponseSchema>;

export const consumerSearchResponseSchema = z.object({
  totalCount: z.number(),
  result: z.array(
    z.object({
      id: z.string().nullable(),
      uniqueId: z.string().nullable(),
      name: z.string().nullable(),
      surname: z.string().nullable(),
      email: z.string().nullable(),
      phoneNumber: z.string().nullable(),
    })
  ),
});

export type ConsumerSearchRequest = z.infer<typeof consumerSearchRequestSchema>;
export type ConsumerSearchResponse = z.infer<typeof consumerSearchResponseSchema>;

export const consumerRegistrationDeletionRequestSchema = z.object({
  minDate: z.string().optional(),
  maxDate: z.string().optional(),
});

export const consumerRegistrationDeletionResponseSchema = z.array(
  z.object({
    date: z.string(),
    registerCount: z.number(),
    deleteAccountCount: z.number(),
    diff: z.number(),
  })
);

export type ConsumerRegistrationDeletionRequest = z.infer<typeof consumerRegistrationDeletionRequestSchema>;
export type ConsumerRegistrationDeletionResponse = z.infer<typeof consumerRegistrationDeletionResponseSchema>;

